import { Link } from "react-router-dom";

export const HitLink = ({ hit, children }) => (
  <Link
    to={`/location/${hit.geometry[0].toFixed(5)},${hit.geometry[1].toFixed(5)}`}
    className="flex"
  >
    {children}
  </Link>
);
